import { MainHeader, Programs, Slider } from "../../Components/index";

import "./home.css";
import { Fragment } from "react";
const Home = () => {
  return (
    <Fragment>
      <MainHeader />
      <Programs />
      <Slider />
    </Fragment>
  );
};
export default Home;
